<div class="row">
  <div class="col-12">
    <div class="d-flex justify-content-start my-1">
      <div class="ml-auto p-2 bd-highlight">
        <button class="btn btn-primary" (click)="addRate()" data-testid="service-rates-create-new-rate">
          Create New Rate
        </button>
      </div>
    </div>
  </div>
  <div class="col-12">
    <ngx-datatable
    class="material service-edit-rate-table"
    [rows]="rates"
    [headerHeight]="50"
    [footerHeight]="40"
    [scrollbarH]="true"
    [rowHeight]="35"
    [columnMode]="columnMode.force"
    [scrollbarV]="true">
      <ngx-datatable-column *ngFor="let column of subTableColumns; let i = index" name="{{column.name}}" prop="{{column.prop}}" [width]="column.width" [cellClass]="getCellClass">
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'chargeTypeId'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            {{displayChargeType(value)}}
          </div>
          <div *ngIf="row.editMode">
            <select class="form-control service-subscription-filter-150" [(ngModel)]="row.editChargeTypeId" [disabled]="!companyServices" [attr.data-testid]="'service-rates-edit-charge-type-id-' + i + '-' + rowIndex">
              <option *ngFor="let cs of chargeTypesList" [value]="cs.id">
                {{cs.chargeTypeName}}
              </option>
            </select>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'serviceCodeId'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            {{displayServiceCode(value)}}
          </div>
          <div *ngIf="row.editMode">
            <select class="form-control service-subscription-filter-150" [(ngModel)]="row.editServiceCodeId" [disabled]="!companyServices" [attr.data-testid]="'service-rates-edit-service-code-id-' + i + '-' + rowIndex">
              <option *ngFor="let sc of serviceCodeList" [value]="sc.serviceCodeId">
                {{sc.description}}
              </option>
            </select>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'rateType'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            {{value}}
          </div>
          <div *ngIf="row.editMode">
            <select class="form-control service-subscription-filter-150" [(ngModel)]="row.editRateType" [attr.data-testid]="'service-rates-edit-rate-type-' + i + '-' + rowIndex">
              <option value="Calculation">Calculation</option>
              <option value="Multiplier">Multiplier</option>
              <option value="Flat Fee">Flat Fee</option>
            </select>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'amount'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            {{value}}
          </div>
          <div *ngIf="row.editMode && row.editRateType != 'Calculation'">
            <input  class="form-control" type="number" [(ngModel)]="row.editAmount" [attr.data-testid]="'service-rates-edit-amount-number-' + i + '-' + rowIndex">
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'isRecurring'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            <span class="text-primary" *ngIf="value">Reoccurring </span>
            <span class="text-warning" *ngIf="!value">Not Reoccurring</span>
          </div>
          <div *ngIf="row.editMode">
            <select  class="form-control service-subscription-filter-150"  [(ngModel)]="row.editIsRecurring" [attr.data-testid]="'service-rates-edit-recurring-' + i + '-' + rowIndex">
              <option class="text-primary" value="Yes">Reoccurring</option>
              <option class="text-warning" value="No">Not Reoccurring</option>
            </select>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'multiplierName'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            {{value}}
          </div>
          <div *ngIf="row.editMode">
            <input  class="form-control " type="text" [(ngModel)]="row.editMultiplierName" [attr.data-testid]="'service-rates-edit-multiplier-name-' + i + '-' + rowIndex">
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'multiplier'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            {{value}}
          </div>
          <div *ngIf="row.editMode && row.editRateType == 'Calculation' ">
            <input  class="form-control" type="number" [(ngModel)]="row.editMultiplier" [attr.data-testid]="'service-rates-edit-multiplier-number-' + i + '-' + rowIndex">
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'name'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            {{value}}
          </div>
          <div *ngIf="row.editMode">
            <input  class="form-control service-subscription-filter-300" type="text" [(ngModel)]="row.editName" [attr.data-testid]="'service-rates-edit-name-' + i + '-' + rowIndex">
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop === 'isEndOfMonth'" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            <span class="text-primary" *ngIf="value">Yes</span>
            <span class="text-warning" *ngIf="!value">No</span>
          </div>
          <div *ngIf="row.editMode" class="pl-3">
            <input type="checkbox" [(ngModel)]="row.editIsEndOfMonth" [attr.data-testid]="'service-rates-edit-end-month-checkbox-' + i + '-' + rowIndex">
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="" [width]="100" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false" [cellClass]="getCellClass">
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row" let-rowIndex="rowIndex">
          <div *ngIf="!row.editMode">
            <span *ngIf="!row.endDate || row.endDate > todaysDate" role="button" (click)="editModeRate(row)" [attr.data-testid]="'service-rates-edit-mode-rate-' + rowIndex">
              <i class="fa-solid fa-pen-to-square fa-lg" ></i>
            </span>
          </div>
          <div *ngIf="row.editMode">
            <span class="text-danger mr-2" *ngIf="!row.savingChanges && row.id == 0" role="button" (click)="removeRow(row)" [attr.data-testid]="'service-rates-remove-row-' + rowIndex">
              <i class="fa-solid fa-x fa-lg"></i>
            </span>
            <span class="text-danger mr-2" *ngIf="!row.savingChanges && row.id != 0" role="button" (click)="editModeRate(row)" [attr.data-testid]="'service-rates-edit-mode-rate-x-' + rowIndex">
              <i class="fa-solid fa-x fa-lg"></i>
            </span>
            <span class="text-primary mx-2" *ngIf="!row.savingChanges" role="button" (click)="saveRate(row)" [attr.data-testid]="'service-rates-save-rate-' + rowIndex">
              <i class="fa-solid fa-floppy-disk fa-lg"></i>
            </span>
            <span class="text-primary ml-1" *ngIf="row.savingChanges">
              <i class="fa-duotone fa-spinner-third fa-spin"></i>
            </span>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/components/service-rates/service-rates.component.html